<template>
  <div class="container">
    <div class="header" v-if="isPhone">
      <!-- <div class="icon"><i class="el-icon-arrow-left"></i></div> -->
      <div class="title">回复留言</div>
      <!-- <div class="icon"></div> -->
    </div>
    <div class="content">
      <el-card class="box-card">
        <div class="item-title">
          <span class="typeName"
            ><span style="font-weight: bold">{{ item.username }}</span
            >留言：</span
          >
          <span class="time">{{ item.createTime }}</span>
        </div>
        <div class="item-content">
          <el-tag size="mini">{{ item.type }}</el-tag>
          <div class="title">{{ item.title }}</div>
          <div class="message-content">{{ item.qcontent }}</div>
        </div>
      </el-card>
      <el-card class="box-card" id="#box-cardss">
        <div class="item-title">
          <span class="typeName">回复：</span>
        </div>
        <div class="item-content">
          <el-input
            type="textarea"
            :rows="5"
            resize="none"
            placeholder="请输入内容"
            v-model="textarea"
          >
          </el-input>
          <div>
            <label>是否在网站显示此留言：</label>
            <el-radio-group v-model="radio">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-card>
      <el-button type="primary" @click="reply">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'messageReply',
  props: ['item', 'isPhone'],
  data () {
    return {
      textarea: '',
      radio: 0
    }
  },
  mounted () {},
  methods: {
    replyTexts () {
      if (this.item.reply.rcontent) {
        this.textarea = this.item.reply.rcontent
      }
    },
    reply () {
      let para = this.item
      para.rcontent = this.textarea
      para.isPublish = this.radio
      this.$emit('reply', para)
      this.textarea = ''
    },
    closeDs () {
      this.textarea = ''
    }
  }
}
</script>
<style lang="scss">
// .el-textarea__inner {
//         padding: 0 ;
//         padding-top: 3px ;
//         font-size: 14px ;
//         color: black ;
// }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color: #6e348b;
.el-message {
  padding: 10px 10px 10px 15px;
}
.h1 {
  font-size: 40px;
}
.header {
  display: flex;
  justify-content: center;
  color: $color;
  padding: 10px 0;
  font-size: 1em;
  font-weight: 600;
  .icon {
    width: 30px;
  }
}
.el-card {
  margin: 10px 0;
  .item-title {
    display: flex;
    color: #606266;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .item-content {
    & > div {
      font-size: 14px;
      color: black;
      margin-bottom: 10px;
    }
  }
}
.el-button {
  width: 100%;
  margin-top: 30px;
}
.typeName{
  font-size: 16px;
  font-weight:bold;
}
</style>



// WEBPACK FOOTER //
// src/components/messageReply.vue